import { ReactComponent as Icon } from "components/common/Icons/Progress/Pie/QuarterOrange/icon.svg";
interface Props {}

const QuarterOrange = (_: Props) => {
  return <Icon />;
};

export default QuarterOrange;
